/*
 * File: vpr.misc.js
 *
 * Desc: js for misc scripts in the theme
 *
 */
(function (Drupal) {
  Drupal.behaviors.vprMisc = {
    attach(context, settings) {
      // add js here
    },
  };
})(Drupal);
